var SCM = SCM || {};

SCM.ArticleMainView = (function ($) {
    return {
        init: _init
    };

    function _init() {
        if (!$('#articleMainView-articleId').length) {
            return;
        }

        if (!App.EnableAdobeAnalytics) {
            return;
        }

        //need to wait for adobe analytics to be ready before executing
        SCM.Retry.policy()
            .handleResult(function (result) { return !result; })
            .waitAndRetry(5, 500)
            .execute(function () {
                return window.digitalData;
            })
            .then(function (result) {
                _sendAdobeAnalyticsArticleData();
            })
            .catch(function (reason) {
                console.error('Timed out waiting for Adobe Analytics to be ready.');
            });
    }

    function _sendAdobeAnalyticsArticleData() {
        if (!_referrerIsOnSameSite()) {
            return;
        }

        var articleId = $('#articleMainView-articleId').data('articleid');
        var isAbstractPage = window.location.href.includes('abstract');
        var match = document.referrer.match(/\/collection\/(\d+)/);
        var collectionId = -1;

        if (match) {
            collectionId = match[1];
        }

        SCM.AdobeAnalytics.sendAdobeAnalyticsArticleData(articleId, isAbstractPage, collectionId);
    }

    function _referrerIsOnSameSite() {
        if (document.referrer) {
            var referralUrl = document.referrer;
            var previousUrl = referralUrl.match(/:\/\/(.[^/]+)/);
            var currentUrl = window.location.hostname;

            if (previousUrl && previousUrl[1] === currentUrl) {
                return true;
            }
        }

        return false;
    }

})(jQuery);

